import { useTranslation } from 'react-i18next';
import {
  ComplianceDocumentDefinition,
  complianceDocumentDefinitionsApi,
} from '@texas/api/endpoints/metadata/complianceDocumentDefinitionsApi';
import { VerifyDialogWithRequest } from '@texas/components/shared/dialog/VerifyDialogWithRequest';
import { SharedDisclosureProps } from '@texas/components/shared/types';

interface ArchiveComplianceDocumentDefinitionProps
  extends SharedDisclosureProps {
  definition: ComplianceDocumentDefinition;
  onArchived: () => void;
}

export function ArchiveComplianceDocumentDefinition({
  definition,
  isOpen,
  onArchived,
  onClose,
}: ArchiveComplianceDocumentDefinitionProps) {
  const { t } = useTranslation();

  return (
    <VerifyDialogWithRequest
      headerTitle={t('complianceDocumentDefinitions.archiveTitle', {
        name: definition.name,
      })}
      secondaryButtonTitle={t('general.cancel')}
      primaryButtonTitle={t('general.confirm')}
      primaryRequest={complianceDocumentDefinitionsApi.archive}
      args={[definition.id]}
      isOpen={isOpen}
      onClose={onClose}
      onPerformed={onArchived}
      onSuccessTitle={t('general.archived')}
    >
      {t('alert.areYouSure')}
    </VerifyDialogWithRequest>
  );
}
